<div class="grid-stack-item-content" [ngClass]="{ isDraggable: draggable }">
  <div
    class="widget-heading"
    (mousedown)="onMouseDown()"
    (mouseup)="onMouseUp()"
  >
    <div class="title">{{ title }}</div>
    <div class="options">
      <button mat-icon-button>
        <svg-icon
          src="assets/svg/trashcan.svg"
          (click)="delete()"
          [svgStyle]="{
            'width.px': '17',
            'height.px': '17'
          }"
          svgClass="grey"
          viewBox="auto"
        ></svg-icon>
      </button>
    </div>
  </div>
  <div class="widget-content" lhpeElementLoader #elementLoader="elementloader">
    <div class="search-box input-box">
      <svg-icon src="assets/svg/magnifier.svg"></svg-icon>

      <mat-form-field>
        <input
          matInput
          (keyup)="applyFilter()"
          matInput
          type="text"
          [(ngModel)]="searchValue"
          [disabled]="!onPropertyUsers.length"
        />
      </mat-form-field>
    </div>
    <div *ngIf="!onPropertyUsers.length" class="no-users">
      <div class="text">
        No guests with location permission are currently on property
      </div>
    </div>
    <div *ngIf="onPropertyUsers.length" class="users">
      <div
        *ngFor="let user of filteredOnPropertyUsers"
        class="user"
        (click)="goToUser(user)"
      >
        <div class="picture">
          <img [src]="user.image" />
        </div>
        <div class="name">
          <ng-container *ngIf="user.first_name || user.last_name">
            {{ user.first_name }}
            {{ user.last_name }}
          </ng-container>
          <ng-container *ngIf="!(user.first_name || user.last_name)">
            No Name
          </ng-container>
          <div class="location">
            {{user.location_name}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
